import React from 'react';
import AamUserManagementToolComponent from './components/AamUserManagementTool';
import PrefixPath from '../../../../../config/AppConfig';

const AamUserManagementTool = () => {
    return (
        <AamUserManagementToolComponent 
            link={PrefixPath.AAL_API_BASE_URL}
            xApiKey={PrefixPath.AAL_API_KEY}
        />
    );
};

export default AamUserManagementTool;
